import { render, staticRenderFns } from "./ConfirmDlg.vue?vue&type=template&id=38f5b0ea&"
import script from "./ConfirmDlg.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDlg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports